const zhCN = {
  orgLoading: '加载组织数据中...',
  searchOrgTxt: '搜索组织名称',
  refreshOrg: '更新组织数据'
}
const enUS = {
  orgLoading: 'Organization loading...',
  searchOrgTxt: 'Search organization',
  refreshOrg: 'Refresh organization'
}

export default { zhCN, enUS }